import { S3Client } from "@aws-sdk/client-s3";

import supabase from "./supabaseClient";

export const getS3Client = async () => {
  const {
    data: { session },
    error,
  } = await supabase.auth.getSession();
  if (error) throw error;

  return new S3Client({
    forcePathStyle: true,
    region: "us-west-1", // Supabase default region
    endpoint: `https://${import.meta.env.VITE_SUPABASE_PROJECT_ID}.supabase.co/storage/v1/s3`,
    credentials: {
      accessKeyId: import.meta.env.VITE_SUPABASE_PROJECT_ID,
      secretAccessKey: import.meta.env.VITE_SUPABASE_ANON_KEY,
      sessionToken: session.access_token,
    },
  });
};

// Helper function to refresh the client when token expires
export const refreshS3Client = async () => {
  const { error } = await supabase.auth.refreshSession();
  if (error) throw error;
  return getS3Client();
};
